<template>
  <el-dialog
    title="部门管理"
    :visible.sync="visible"
    top="29vh"
    width="600px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="部门名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder=""
            maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :autosize="{ minRows: 3 }"
            placeholder="请输入服务描述"
            maxlength="1000"
            show-word-limit
            resize="none"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <p class="submit fn-text-center">
        <template v-if="infoId">
          <el-button type="primary" @click="handlerModifyData('ruleForm')"
            >修改
          </el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="handlerAddData('ruleForm')"
            >提交</el-button
          >
        </template>
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    infoId: {
      type: String,
      required: true
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      visible: true,
      form: {
        name: "",
        description: "",
        status: 1
      },
      rules: {
        name: [isEmpty("请输入部门名称")],
        status: [isEmpty("请选择启用状态")]
      },
      isLoading: false
    };
  },
  created() {
    if (this.infoId) {
      this.loadInfo();
    }
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      return this.form;
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      return data;
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("privilege", "addDepartment", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("privilege", "addDepartment", {
        ...params,
        id: this.infoId
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      this.$api("privilege", "getDepartmentInfo", { id: this.infoId }).then(
        (res) => {
          const { code, message } = res;
          if (code === 0) {
            this.form = this.downloadProcessData(res.data);
          } else {
            this.$message.error(message);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped></style>
